export default __webpack_public_path__ + "static/media/yw-icons.381f5741.ttf";